import { render, staticRenderFns } from "./AssignDocument.vue?vue&type=template&id=43541d2e&scoped=true"
import script from "./AssignDocument.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignDocument.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AssignDocument.vue?vue&type=style&index=0&id=43541d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43541d2e",
  null
  
)

export default component.exports